<template>
  <b-modal
    id="createContactActivtyModal"
    :title="modalTitleExt"
    size="lg"
    hide-footer
  >
    <b-card>
      <validation-observer
        ref="createContactActivtyModal"
      >
        <b-form
          autocomplete="off"
          @submit.prevent="addActivitySubmit"
        >
          <b-row>
            <b-col md="6">
              <b-form-group
                :label="t('Action')"
                label-for="vi-activity_type"
                class="required"
              >
                <validation-provider
                  #default="{ errors }"
                  class="input-group"
                  name="Action"
                  vid="vi-activity_type"
                  rules="required"
                >
                  <v-select
                    v-model="form.para_activity_type_id"
                    class="p-0 border-0 w-100"
                    :class="errors[0] ? 'border-red-vselect' : ''"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="para_value"
                    :placeholder="t('Select Action')"
                    :reduce="sub => sub.para_id"
                    :options="activityTypes"
                  />
                  <small class="text-danger">{{ t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="t('Response')"
                label-for="vi-response"
                class="required"
              >
                <validation-provider
                  #default="{ errors }"
                  class="input-group"
                  name="Response"
                  vid="vi-response"
                  rules="required"
                >
                  <v-select
                    v-model="form.response"
                    class="p-0 border-0 w-100"
                    :class="errors[0] ? 'border-red-vselect' : ''"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="para_value"
                    :placeholder="t('Select Response')"
                    :reduce="sub => sub.para_id"
                    :options="activityResponse"
                  />
                  <small class="text-danger">{{ t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="t('Remark')"
                label-for="vi-remark"
              >
                <validation-provider
                  #default="{ errors }"
                  class="input-group"
                  name="Remark"
                  vid="vi-remarks"
                  rules=""
                >
                  <b-input-group class="input-group-merge">
                    <b-form-textarea
                      id="vi-remark"
                      v-model="form.remarks"
                      autocomplete="off"
                      :class="errors[0] ? 'border-red' : ''"
                      :placeholder="t('Remarks')"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                :label="t('Activity Date')"
                label-for="vi-datetime"
                class="required"
              >
                <validation-provider
                  #default="{ errors, validate }"
                  name="Activity Date"
                  vid="vi-activity_date_time"
                  rules="required"
                  mode="eager"
                >
                  <flat-pickr
                    id="vi-activity_date_time"
                    ref="activityDateTime"
                    v-model="form.activity_date_time"
                    :placeholder="t('Select Activity Date')"
                    :class="errors[0] ? 'form-control border-red' : 'form-control'"
                    :config="dateConfig"
                    @change="validate"
                  />
                  <small class="text-danger">{{ t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="text-right"
            >
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
              >
                {{ t('Submit') }}
              </b-button>
              <b-button
                type="button"
                variant="outline-secondary"
                @click="modalCancel"
              >
                {{ t('Cancel') }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils } from '@core/libs/i18n'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import moment from 'moment'
import store from '@/store'
import constants from '@/constants'
import {
  hideLoader, showLoader,
} from '@/utils/common'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    vSelect,
  },
  setup() {
    const { t } = useUtils()
    return { t }
  },
  data() {
    return {
      modalTitleExt: this.$i18n.t('Add Activity'),
      date_error: false,
      form: {
        contact_universe_id: '',
        remarks: '',
        activity_date_time: '',
        para_activity_type_id: '',
        id: '',
      },
      activityTypes: [],
      activityResponse: [
        {
          para_id: 1,
          para_value: 'Yes',
        },
        {
          para_id: 0,
          para_value: 'No',
        },
      ],
      dateConfig: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:S',
        allowInput: true,
        clickOpens: true,
      },
    }
  },
  mounted() {
    store.dispatch('storeSetting/getParametersByParentId', { para_parent_id: constants.parentParameterIds.ContactUniverseActivityType }).then(response => {
      this.activityTypes = response.data.data
    })
    this.$root.$on('bv::modal::hidden', (a, componentId) => {
      if (componentId === 'createContactActivtyModal') {
        this.form = {
          contact_universe_id: '',
          remarks: '',
          activity_date_time: '',
          para_activity_type_id: '',
          response: '',
          id: '',
        }
      }
    })
    this.$root.$on('getContactId', contactId => {
      this.form.contact_universe_id = contactId
    })
    this.$root.$on('getActivityFormData', formData => {
      const date = moment(formData.activity_date_time).format('YYYY-MM-DD HH:mm:ss')
      this.form = {
        contact_universe_id: formData.contact_universe_id || '',
        remarks: formData.remarks || '',
        activity_date_time: date || '',
        para_activity_type_id: formData.para_activity_type_id || '',
        response: formData.response ? 1 : 0,
        id: formData.id || '',
      }
      this.modalTitleExt = this.$i18n.t('Edit Activity')
    })
    if (this.$route.params.id) {
      this.form.id = +this.$route.params.id
    }
  },
  methods: {
    modalCancel() {
      this.$bvModal.hide('createContactActivtyModal')
    },
    addActivitySubmit() {
      this.$refs.createContactActivtyModal.validate().then(success => {
        if (success) {
          this.addActivity()
        }
      })
    },
    async addActivity() {
      showLoader()
      let dispatchAction = 'ManageContact/updateContactActivity'
      if (this.form.id === '') {
        dispatchAction = 'ManageContact/createContactActivity'
        delete this.form.id
      }
      this.form.activity_date_time = moment(this.form.activity_date_time).format('YYYY-MM-DD HH:mm:ss')
      await store.dispatch(dispatchAction, this.form).then(response => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == constants.SUCCESS) {
          this.$bvModal.hide('createContactActivtyModal')
          hideLoader()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: response.data.msg,
              icon: 'CheckCircleIcon',
              variant: 'success',
              text: '',
            },
          })
          this.$refs.createContactActivtyModal.reset()
          if (this.form.id) {
            this.$root.$emit('refreshContactActivityData')
          }
        } else {
          hideLoader()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: response.data.msg,
              icon: 'Danger',
              variant: 'danger',
              text: '',
            },
          })
        }
      }).catch(e => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: e.msg,
            icon: 'Danger',
            variant: 'danger',
            text: '',
          },
        })
        hideLoader()
      })
    },
  },
}
</script>

<style>
.fieldset-style {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 15px;
}
</style>
